// Login — the FIRST screen of the app ("app wall").
// Username + password against the license server's /auth/login.
// A successful USER login lands on the ColorSep editor (/app);
// an ADMIN login lands on the admin panel (/admin).

import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

export function LoginPage() {
  const { login, loading, error, clearError } = useAuth();
  const nav = useNavigate();
  const [username, setUsername] = useState('');
  const [password, setPassword] = useState('');

  const submit = async (e: React.FormEvent) => {
    e.preventDefault();
    if (loading) return;
    try {
      const user = await login(username, password);
      nav(user.role === 'admin' ? '/admin' : '/app', { replace: true });
    } catch {
      /* error text is rendered from state */
    }
  };

  return (
    <div data-screen className="login-screen">
      <main className="auth-main">
        <section className="card auth-card" aria-label="Sign in">
          <div className="login-logo">
            <span className="logo-dot" aria-hidden="true" />
            <span className="login-product">ColorSep</span>
          </div>
          <h1 className="login-title">Sign in</h1>
          <form onSubmit={submit} className="login-block" autoComplete="on">
            <label className="field-label" htmlFor="login-username">Username</label>
            <input
              id="login-username"
              type="text"
              autoComplete="username"
              autoFocus
              value={username}
              onChange={(e) => { if (error) clearError(); setUsername(e.target.value); }}
              placeholder="kullanıcı adı"
            />
            <label className="field-label" htmlFor="login-password">Password</label>
            <input
              id="login-password"
              type="password"
              autoComplete="current-password"
              value={password}
              onChange={(e) => { if (error) clearError(); setPassword(e.target.value); }}
              placeholder="şifre"
            />
            <button className="btn primary login-submit" type="submit" disabled={loading || !username || !password}>
              {loading ? 'Signing in…' : 'Sign in'}
            </button>
          </form>
          {error && <p className="err-msg" role="alert">{error}</p>}
          <p className="dim login-note">
            Hesap bilgileri tarafınıza verilmiştir. Şifrenizi unuttuysanız yöneticinizle iletişime geçin.
          </p>
        </section>
      </main>
    </div>
  );
}
